import { BadgeIcon } from '@/shared/ui/badge-icon';
import { Spinner } from '@/shared/ui/spinner';

export function LinkCheckingView() {
  return (
    <>
      <span data-enter="">
        <BadgeIcon>
          <Spinner size="lg" />
        </BadgeIcon>
      </span>
      <div data-enter="" className="flex flex-col gap-2" role="status">
        <h1 className="font-semibold text-title-lg">Signing you in</h1>
        <p className="text-muted">This takes a moment.</p>
      </div>
    </>
  );
}
